import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { L10nTranslationModule } from 'angular-l10n';

/**
 * L2-S13: moved verbatim from `src/app/shared/dialogs/session-expiry-dialog/` (now a shim) so
 * `TimetrackingService` — which opens it when the idle timer fires — can live in `@miq/platform`.
 * The service reaches this class through the `SESSION_EXPIRY_DIALOG` token (platform must not
 * import platform-ui); BOTH shells provide the token, so even a standalone remote serve shows the
 * real dialog. Two dead members were dropped on the move: an unused `MatDialog` inject and an
 * unused `MAT_DIALOG_DATA` (the service passes no `data`). Its two l10n keys stay in the host's
 * asset catalogs like every other dialog in this library.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-session-expiry-dialog',
  templateUrl: './session-expiry-dialog.component.html',
  styleUrl: './session-expiry-dialog.component.scss',
  imports: [L10nTranslationModule],
})
export class SessionExpiryDialogComponent {
  public dialogRef = inject(MatDialogRef<SessionExpiryDialogComponent>);
  continue() {
    this.dialogRef.close();
  }
}
